import React, { useState } from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import { Link } from 'gatsby'

import Layout from '../layouts'
import Grid from '../components/elements/grid'
import { Canon, SizedText, Body } from '../components/elements/typography'
import Icon from '../components/elements/icon'
import SEO from '../components/elements/seo'

import rightArrowIcon from "../theme/icons/right-arrow.svg"
import userIcon from "../theme/icons/user-solid.svg"
import passwordIcon from "../theme/icons/password-solid.svg"

const LoginPage = () => {

  const [username, setUsername] = useState(null);
  const [password, setPassword] = useState(null);

  const handleUsernameChange = (event) => {
    setUsername(event.target.value);
  }

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  }

  return (
    <Layout isSubMenuOpen={false} forceRootMenu="/">

      {/* ---- PAGE SEO SETTINGS ---- */}
      <SEO
        title="The Claxton Bank | Online Banking Login | NuFund | WebRDC"
        description="Log in to your secure digital banking account by entering your username and password. "
        location="/login"
        ogImg='/images/social-graph/the-claxton-bank.jpg'
      />

        <Grid.FullWidthSection 
          styles={{
            position: `relative`,
            overflowX: `hidden`,
            boxShadow: `inset 0px 11px 8px -10px rgba(0,0,0,0.4), inset 0px -11px 8px -10px rgba(0,0,0,0.4)`,
            '@media (min-width: 820px)': { 
              backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='250' viewBox='0 0 1080 900'%3E%3Cg fill-opacity='0.02'%3E%3Cpolygon fill='%23444' points='90 150 0 300 180 300'/%3E%3Cpolygon points='90 150 180 0 0 0'/%3E%3Cpolygon fill='%23AAA' points='270 150 360 0 180 0'/%3E%3Cpolygon fill='%23DDD' points='450 150 360 300 540 300'/%3E%3Cpolygon fill='%23999' points='450 150 540 0 360 0'/%3E%3Cpolygon points='630 150 540 300 720 300'/%3E%3Cpolygon fill='%23DDD' points='630 150 720 0 540 0'/%3E%3Cpolygon fill='%23444' points='810 150 720 300 900 300'/%3E%3Cpolygon fill='%23FFF' points='810 150 900 0 720 0'/%3E%3Cpolygon fill='%23DDD' points='990 150 900 300 1080 300'/%3E%3Cpolygon fill='%23444' points='990 150 1080 0 900 0'/%3E%3Cpolygon fill='%23DDD' points='90 450 0 600 180 600'/%3E%3Cpolygon points='90 450 180 300 0 300'/%3E%3Cpolygon fill='%23666' points='270 450 180 600 360 600'/%3E%3Cpolygon fill='%23AAA' points='270 450 360 300 180 300'/%3E%3Cpolygon fill='%23DDD' points='450 450 360 600 540 600'/%3E%3Cpolygon fill='%23999' points='450 450 540 300 360 300'/%3E%3Cpolygon fill='%23999' points='630 450 540 600 720 600'/%3E%3Cpolygon fill='%23FFF' points='630 450 720 300 540 300'/%3E%3Cpolygon points='810 450 720 600 900 600'/%3E%3Cpolygon fill='%23DDD' points='810 450 900 300 720 300'/%3E%3Cpolygon fill='%23AAA' points='990 450 900 600 1080 600'/%3E%3Cpolygon fill='%23444' points='990 450 1080 300 900 300'/%3E%3Cpolygon fill='%23222' points='90 750 0 900 180 900'/%3E%3Cpolygon points='270 750 180 900 360 900'/%3E%3Cpolygon fill='%23DDD' points='270 750 360 600 180 600'/%3E%3Cpolygon points='450 750 540 600 360 600'/%3E%3Cpolygon points='630 750 540 900 720 900'/%3E%3Cpolygon fill='%23444' points='630 750 720 600 540 600'/%3E%3Cpolygon fill='%23AAA' points='810 750 720 900 900 900'/%3E%3Cpolygon fill='%23666' points='810 750 900 600 720 600'/%3E%3Cpolygon fill='%23999' points='990 750 900 900 1080 900'/%3E%3Cpolygon fill='%23999' points='180 0 90 150 270 150'/%3E%3Cpolygon fill='%23444' points='360 0 270 150 450 150'/%3E%3Cpolygon fill='%23FFF' points='540 0 450 150 630 150'/%3E%3Cpolygon points='900 0 810 150 990 150'/%3E%3Cpolygon fill='%23222' points='0 300 -90 450 90 450'/%3E%3Cpolygon fill='%23FFF' points='0 300 90 150 -90 150'/%3E%3Cpolygon fill='%23FFF' points='180 300 90 450 270 450'/%3E%3Cpolygon fill='%23666' points='180 300 270 150 90 150'/%3E%3Cpolygon fill='%23222' points='360 300 270 450 450 450'/%3E%3Cpolygon fill='%23FFF' points='360 300 450 150 270 150'/%3E%3Cpolygon fill='%23444' points='540 300 450 450 630 450'/%3E%3Cpolygon fill='%23222' points='540 300 630 150 450 150'/%3E%3Cpolygon fill='%23AAA' points='720 300 630 450 810 450'/%3E%3Cpolygon fill='%23666' points='720 300 810 150 630 150'/%3E%3Cpolygon fill='%23FFF' points='900 300 810 450 990 450'/%3E%3Cpolygon fill='%23999' points='900 300 990 150 810 150'/%3E%3Cpolygon points='0 600 -90 750 90 750'/%3E%3Cpolygon fill='%23666' points='0 600 90 450 -90 450'/%3E%3Cpolygon fill='%23AAA' points='180 600 90 750 270 750'/%3E%3Cpolygon fill='%23444' points='180 600 270 450 90 450'/%3E%3Cpolygon fill='%23444' points='360 600 270 750 450 750'/%3E%3Cpolygon fill='%23999' points='360 600 450 450 270 450'/%3E%3Cpolygon fill='%23666' points='540 600 630 450 450 450'/%3E%3Cpolygon fill='%23222' points='720 600 630 750 810 750'/%3E%3Cpolygon fill='%23FFF' points='900 600 810 750 990 750'/%3E%3Cpolygon fill='%23222' points='900 600 990 450 810 450'/%3E%3Cpolygon fill='%23DDD' points='0 900 90 750 -90 750'/%3E%3Cpolygon fill='%23444' points='180 900 270 750 90 750'/%3E%3Cpolygon fill='%23FFF' points='360 900 450 750 270 750'/%3E%3Cpolygon fill='%23AAA' points='540 900 630 750 450 750'/%3E%3Cpolygon fill='%23FFF' points='720 900 810 750 630 750'/%3E%3Cpolygon fill='%23222' points='900 900 990 750 810 750'/%3E%3Cpolygon fill='%23222' points='1080 300 990 450 1170 450'/%3E%3Cpolygon fill='%23FFF' points='1080 300 1170 150 990 150'/%3E%3Cpolygon points='1080 600 990 750 1170 750'/%3E%3Cpolygon fill='%23666' points='1080 600 1170 450 990 450'/%3E%3Cpolygon fill='%23DDD' points='1080 900 1170 750 990 750'/%3E%3C/g%3E%3C/svg%3E")`,
              padding: `10rem 0`,
              alignItems: `center`,
              overflowX: `hidden`,        
            }
          }}>
            <Grid.Block start="1" span="14">
              <div css={{
                width: `100vw`,
                overflow: `hidden`,
                display: `grid`,
                gridTemplateColumns: `1fr`,
                '@media (min-width: 820px)': { 
                  borderRadius: `1rem`,
                  margin: `0 auto`,
                  border: `1px solid #bdc3c7`,
                  backgroundColor: `#fff`,
                  boxShadow: `1px 7px 21px -15px rgba(0,0,0,0.75), 1px -7px 21px -15px rgba(0,0,0,0.75)`,
                  width: `754px`,
                },
                '@media (min-width: 1257px)': {
                  width: `1225px`,
                  gridTemplateColumns: `1.15fr 1.85fr`,
                }
              }}
            >

              {/* --- LEFT SIDE PICTURE --- */ }
              <Link to="" css={{
                display: `none`,
                '@media (min-width: 1257px)': {
                  display: `block`,
                  gridColumn: `1/ span 1`,
                  //backgroundColor:`rgb(148, 197, 227)`,
                  //fill:`rgba(94, 166, 209, 0.1)`,
                  //backgroundSize:`369px 369px`,
                  //backgroundRepeat:`repeat`,
                  //backgroundImage:`url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 500 500' fill-opacity='1' style='enable-background:new 0 0 500 500'%3E%3Cstyle%3E .st2{fill:rgba(94, 166, 209, 0.15)} %3C/style%3E%3Cg style='display:none'%3E%3Cpath style='display:inline;fill:%236D6E71' d='M-64.9-73.9h675v675h-675z' id='Layer_2'/%3E%3C/g%3E%3Cg id='Layer_1'%3E%3Ccircle class='st2' cx='417.4' cy='83.7' r='82.8'/%3E%3Cpath class='st2' d='M78.1 82.7C78.1 38.2 43.1 2-.8 0v165.3c43.9-2 78.9-38.2 78.9-82.6zM87.9 82.7c0 44.4 35 80.7 78.9 82.7V0c-43.9 2-78.9 38.2-78.9 82.7zM167.2 167.3v165.3c43.9-2 78.9-38.2 78.9-82.7s-34.9-80.6-78.9-82.6zM332.8 332.7V167.3c-43.9 2-78.9 38.2-78.9 82.7s34.9 80.7 78.9 82.7zM417.3 253.7c-44.4 0-80.7 35-82.7 78.9H500c-2-43.9-38.2-78.9-82.7-78.9zM417.3 246.5c44.4 0 80.7-35 82.7-78.9H334.7c2 43.9 38.2 78.9 82.6 78.9zM84 421.1c-44.4 0-80.7 35-82.7 78.9h165.3c-2-43.9-38.2-78.9-82.6-78.9zM84 413.4c44.4 0 80.7-35 82.7-78.9H1.3c2 43.9 38.2 78.9 82.7 78.9zM250.1 78.9c44.4 0 80.7-35 82.7-78.9H167.4c2 43.9 38.3 78.9 82.7 78.9zM250.1 87.5c-44.4 0-80.7 35-82.7 78.9h165.3c-1.9-43.9-38.2-78.9-82.6-78.9z'/%3E%3Ccircle class='st2' cx='84.1' cy='250.1' r='82.8'/%3E%3Cpath class='st2' d='M167.2 334.5v165.3c43.9-2 78.9-38.2 78.9-82.7s-34.9-80.6-78.9-82.6zM421.9 417.2c0 44.4 35 80.7 78.9 82.7V334.6c-43.9 1.9-78.9 38.2-78.9 82.6z'/%3E%3Ccircle class='st2' cx='333.2' cy='417.3' r='82.8'/%3E%3C/g%3E%3C/svg%3E");`,
                  backgroundImage: `url("/images/chat-bg.png")`,
                  padding: `2.2rem 2rem 0 2rem`,
                  borderRight: `1px solid #4f7c9e`,
                  textDecoration: `none`,
                } 
              }}>
                <h2 css={{fontWeight: 200, marginBottom: `0`, color: `#182852`}}><SizedText as="span" smallSize="2.281" largeSize="1.424">Get Help Your Way With</SizedText></h2>
                <h2 css={{marginTop: `0`, color: `#182852`, textTransform: `uppercase`, marginBottom: `0`}}><SizedText as="span" smallSize="2.281" largeSize="2.566">LIVE CHAT SUPPORT</SizedText></h2>    

                <Body css={{padding: `2rem 0`, color: `#f2f2f2`}}>
                You are never alone with TCB.  We’re on a mission to make banking simple, and getting help when you need it should be simple too.  That’s why we’re proud to introduce live chat support.  Now you 
          can get answers to basic questions like “what is our routing number” 24/7 via TCB Tom, our interactive chat-bot support assistant, and help from a live TCB team member during regular business hours, 
          online, and on your time.  
                </Body>
                <div css={{paddingBottom: `2rem`}}>
                  <StaticImage src="../images/chat-hero.png" alt=""/>
                </div>
              </Link>


              {/* --- LOGIN FORM --- */ }
              <div css={{
                gridColumn: `1 / span 1`,
                padding: `6rem 1rem 7rem 1rem`,
                '@media (min-width: 820px)': { padding: `3rem 4rem`, },
                '@media (min-width: 1257px)': { gridColumn: `2/ span 2` }
              }}>
                <Canon>Digital Banking Login</Canon>
                <div css={{padding: `1rem 1rem 0 1rem `}}>
                  <form name="McMForm" id="McMForm" method="post" target="_top" action="https://theclaxtonbank.myebanking.net" css={{

                    '.inputContainer': {
                      display: `flex`,
                      width: `100%`,
                      marginBottom: `1.5rem`,
                    },
                    '.inputIcon': {
                      padding: `8px`,
                      background: `#3265da`,
                      color: `#d7e3f4`,
                      minWidth: `50px`,
                      textAlign: `center`,
                      borderTopLeftRadius: `0.5rem`,
                      borderBottomLeftRadius: `0.5rem`,
                      fontSize: `1.266rem`,
                    },


                    'input[type=text], input[type=password]': {
                      borderTopLeftRadius: `0`,
                      borderBottomLeftRadius: `0`,
                      width: `100%`,
                      padding: `8px`,
                      outline: `none`,
                      borderTopRightRadius: `0.5rem`,
                      borderBottomRightRadius: `0.5rem`,
                      border: `1px solid #bdc3c7`,
                      fontSize: `1em`,
                      height: `2rem`
                    }
                  }}>
                    <div className='inputContainer' id="McMUserNameDiv">
                      <div className="inputIcon"><Icon icon={userIcon} overrides={{verticalAlign: `-0.25rem !important`}}/></div>
                      <input name="UserName" type="text" id="McMUserID" placeholder='Username' autoFocus value={username} onChange={handleUsernameChange}/>
                    </div>
                    <div className='inputContainer' id="McMPasswordDiv">
                      <div className="inputIcon"><Icon icon={passwordIcon} overrides={{verticalAlign: `-0.25rem !important`}}/></div>
                      <input name="Password" type="password" id="McMPassword" placeholder='Password' value={password} onChange={handlePasswordChange}/>
                    </div>
                    <div id="McMLoginButtonDiv">
                      <button
                        type="submit" 
                        css={{
                          padding: `0.6rem 1.5rem 0.5rem 1.5rem`,
                          borderRadius: `0.5rem`,
                          border: `1px solid #27ae60`,
                          color: `#fff`,
                          textDecoration: `none`,
                          fontSize: `1.125rem`,
                          backgroundColor: `#2ecc71`,
                          transition: `all 0.8s ease-out`,
                          transitionDelay: `250ms`,
                          'span': { fontSize: `1rem`},
                          '&:disabled, [disabled], &:disabled:hover, [disabled]:hover': {
                            backgroundColor: `#ecf0f1`,
                            border: `1px solid #d8dedf`,
                            color: `#d8dedf`,
                            cursor: `not-allowed`,
                          },
                          '&:hover': {
                            backgroundColor: `#2ae77e`,
                            color: `#fff`,
                          }
                        }}
                        disabled={!username || !password}
                      >
                        <span>Sign In</span>
                        <span css={{paddingLeft: `0.75rem`}}><Icon icon={rightArrowIcon} overrides={{verticalAlign: `-0.2rem !important`}}/></span>
                      </button>
                    </div>
                  </form>
                </div>
                <div css={{margin: `1.5rem 1rem 3rem 1rem`}}>
                  <small>
                    <a href="https://theclaxtonbank.myebanking.net/#/forgot-username">Forgot username</a> &nbsp; &nbsp;  &nbsp; 
                    <a href="https://theclaxtonbank.myebanking.net/#/forgot-password">Forgot password</a> &nbsp;  &nbsp;  &nbsp; 
                      <a href="https://theclaxtonbank.myebanking.net/#/self-registration">Sign Up</a> 
                  </small>
                </div>




                
                {/* --- OTHER APPS --- */}
                <div css={{
                  borderTop: `1px solid #bdc3c7`,
                  marginRight: `1rem`,
                  padding: `2rem 1rem 0 1rem`, 
                  '@media (min-width: 600px)': { marginRight: `0` }
                }}>
                  <div css={{
                    display: `grid`,
                    gridTemplateColumns: `1fr`,
                    'div': {
                      lineHeight: `1rem !important`,
                      padding: `0 1rem`,
                      gridColumn: `span 1`,
                      'h3': { fontSize: `0.899rem`, margin: `0`, color: `#7f8c8d`},
                      'small': {display: `block`, color: `#7f8c8d`, margin: `0.25rem 0 0.75rem 0`},
                      'a': {display: `block`, fontSize: `0.79rem`}
                    },
                    '@media (min-width: 600px)': {
                      gridTemplateColumns: `1fr 1fr`,
                      padding: `2rem 1rem 0 1rem`
                    }
                  }}>

                    <div>
                      <h3>NuFund Account Opening</h3>
                      <small>Resume an online application or verify a challenge deposit.</small>
                      <a href="https://theclaxtonbank.csinufund.com/home/existingUser">
                        <span>Log in to NuFund</span>
                        <span css={{paddingLeft: `0.75rem`}}><Icon icon={rightArrowIcon} overrides={{verticalAlign: `-0.2rem !important`}}/></span>
                      </a>
                    </div>
                    <div css={{
                      borderTop: `1px solid #bdc3c7`,
                      marginTop: `2rem`,
                      '@media (min-width: 600px)': { 
                        border: `none`,
                        margin: `0`,
                      }
                    }}>
                      <h3 css={{paddingTop: `2rem`, '@media (min-width: 600px)': { paddingTop: `0`}}}>WebRDC Merchant Capture</h3>
                      <small>Scan and deposit multiple checks quickly and easily from your office.</small>
                      <a href="https://tcb.msird.com/Login.aspx?ReturnUrl=%2f">
                        <span>Log in to WebRDC</span>
                        <span css={{paddingLeft: `0.75rem`}}><Icon icon={rightArrowIcon} overrides={{verticalAlign: `-0.2rem !important`}}/></span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            </Grid.Block>
        </Grid.FullWidthSection>
    </Layout>
  )
}

export default LoginPage
